/** Presence announced as text to screen readers, never color alone. */
export function PresenceDot(props: { kind: "ok" | "attention" | "muted"; srLabel: string }) {
  const color =
    props.kind === "ok" ? "var(--ok)" : props.kind === "attention" ? "var(--attention)" : "var(--ink-soft)";
  return (
    <>
      <span
        aria-hidden
        className="inline-block h-2 w-2 shrink-0 rounded-full transition-colors duration-[var(--dur-standard)]"
        style={{ background: color }}
      />
      <span className="sr-only">{props.srLabel}</span>
    </>
  );
}
